import OrderService from './OrderService';

import apiService from '../ApiService';

export default new OrderService(apiService);
